import { Injector } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { InsightsUtility } from '../utilities/insights/insights.utility';
import { ApplicationStartEvent } from '../insights/events/application-start.event';

/**
 * Loads the main application configuration
 * @param injector
 */
export const loadConfiguration = (injector: Injector): Promise<void> => new Promise((resolve) => {
	const config = injector.get(AppConfigService);
	config.loadAppConfig().subscribe(() => {
		const insightsUtility = injector.get(InsightsUtility);
		insightsUtility.event(new ApplicationStartEvent());
		resolve();
	});
});



